<template>
    <div>
        <div v-if="isOrder || 1 !== status" class="dropDown form-group">
            <select class="w-100 form-control custom-select" v-model="selectedStatus" @change="onChange" :disabled="disabled">
                <option v-for="_status in statuses" :value="_status.ID" :key="_status.ID">
                    {{ __(_status.statusName) }}
                </option>
            </select>

            <a v-if="7 === status && !isOrder" href="#" class="pl-1 pt-2 d-block" @click.prevent="selectFragment('lost')">{{ __('View lost reason') }}</a>
        </div>

        <!-- Modal -->
        <!-- TODO: component -->
        <transition name="modal" v-if="modalShown">
            <div class="modal-mask">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">{{ __(modalTax ? 'Tax Code Missing' : 'Mark this enquiry as received?') }}</h5>

                            <button type="button" class="close" @click="modalShown = false; modalTax = false">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <div class="modal-body" v-if="modalTax">
                            {{ __('You cannot mark this enquiry as received without a tax code.') }}
                        </div>

                        <div class="modal-body" v-if="!modalTax && overrideRequired && !overriden">
                            {{ __('You need this enquiry to be overriden.') }}
                        </div>

                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary" @click="modalOkay" v-if="!modalTax && (!overrideRequired || overriden)">{{ __('I\'m Sure') }}</button>
                            <button type="button" class="btn btn-secondary" @click="modalShown = false; modalTax = false">{{ __('Cancel') }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: "EnqPortionProgressStatus",

    props: {
        status: {
            required: true,
            type: Number,
        },
        userId: {
            required: true,
            type: Number,
        },
        enquiryUserId: {
            required: true,
            type: Number,
        },
        isManager: {
            required: true,
            type: Boolean,
        },
        statuses: {
            required: true,
            type: Array,
        },
        changeStatus: {
            required: true,
            type: Function,
        },
        selectFragment: {
            required: true,
            type: Function,
        },
        isOrder: {
            required: true,
            type: Boolean,
        },
        countryCode: {
            required: true,
            type: String,
        },
        overrideRequired: {
            required: true,
            type: Boolean,
        },
        overriden: {
            required: true,
            type: Boolean,
        },
    },

    data() {
        return {
            selectedStatus: this.status,

            modalShown: false,
            modalTax: false,
        };
    },

    computed: {
        disabled() {
            return (
                (!this.isManager && this.userId !== this.enquiryUserId) ||
                this.status > (this.isOrder ? 12 : 5)
            );
        },
    },

    methods: {
        onChange() {
            if (this.selectedStatus === 7 && !this.isOrder) {
                this.selectFragment("lost");
            } else if (this.selectedStatus === 6 && !this.isOrder) {
                // TODO: get this from daxis config
                if (
                    this.countryCode in
                        [
                            "AT",
                            "BE",
                            "BG",
                            "HR",
                            "CY",
                            "CZ",
                            "DK",
                            "EE",
                            "FI",
                            "FR",
                            "DE",
                            "GR",
                            "HU",
                            "IE",
                            "IT",
                            "LV",
                            "LT",
                            "LU",
                            "MT",
                            "NL",
                            "PL",
                            "PT",
                            "RO",
                            "SK",
                            "SI",
                            "ES",
                            "SE",
                        ] &&
                    _.isEmpty(this.enquiry.company_contact.branch.taxCode)
                ) {
                    this.modalTax = true;
                }

                this.modalShown = true;
            } else {
                this.changeStatus(this.selectedStatus);
            }

            this.selectedStatus = this.status; // get update from prop
        },

        modalOkay() {
            this.modalShown = false;
            this.selectedStatus = 6;

            this.changeStatus(6);

            this.selectedStatus = this.status; // get update from prop
        },
    },

    watch: {
        status: function (_new) {
            this.selectedStatus = _new;
        },
    },
};
</script>
